import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Address } from '../../api/app-types/address.app';

/**
 * Validator that requires a complete address.
 * Returns `{ required: true }` if the control value is `undefined`, not an object,
 * or if either `streetAndHouseNumber` or `postalCodeAndCity` is not a non-empty string (after trim).
 */
export const addressRequired: ValidatorFn = (ctrl: AbstractControl): ValidationErrors | null => {
	const v = ctrl.value as { streetAndHouseNumber?: unknown; postalCodeAndCity?: unknown } | undefined;

	if (v === undefined) return { required: true };

	if (typeof v !== 'object' || v === null) return { required: true };

	const ok =
		isNonEmptyString((v as Address).streetAndHouseNumber) && isNonEmptyString((v as Address).postalCodeAndCity);

	return ok ? null : { required: true };
};

// Returns true if the value is a non empty string
function isNonEmptyString(v: unknown): boolean {
	return typeof v === 'string' && v.trim().length > 0;
}
